import { OfferContext, TOfferContext } from '../../../context';
import { OfferCardContainer } from '../OfferCard';

export function OfferContainer(props: TOfferContext) {
  return (
    <OfferContext.Provider value={props}>
      <OfferCardContainer />
    </OfferContext.Provider>
  );
}
